import { render, staticRenderFns } from "./Autodig.vue?vue&type=template&id=24d62978"
import script from "./Autodig.vue?vue&type=script&lang=js"
export * from "./Autodig.vue?vue&type=script&lang=js"
import style0 from "./Autodig.vue?vue&type=style&index=0&id=24d62978&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports